import { makeAwsSignedRequest } from '../ApiService';

const BATCHER_BASE = 'batcher-api';

export interface ParameterInfo {
    name: string;
    type: string;
    description: string;
}

/** Mirrors FunctionMetadata returned by ListFunctionsRequestHandler (GET /batcher-api/functions). */
export interface FunctionMetadata {
    functionName: string;
    functionIdentifier: string;
    aiContext: string;
    inputSchema: ParameterInfo[];
    additionalArguments: ParameterInfo[];
    outputSchema: ParameterInfo[];
    flatMap: boolean;
    requiresAuthentication: boolean;
}

export const BatcherService = {
    /** Fetch the list of available batcher functions with their metadata. */
    listFunctions: (stage: string, realm: string): Promise<FunctionMetadata[]> =>
        makeAwsSignedRequest(stage, realm, `${BATCHER_BASE}/functions`),
};
